import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDecimalNumber]',
})
export class DecimalNumberDirective {

  private regex: RegExp = /^\d*\.?\d{0,2}$/;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  /** Allow only valid decimal input while typing */
  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = this.el.nativeElement;
    let value = input.value;

    // Remove invalid characters
    value = value.replace(/[^0-9.]/g, '');

    // Prevent multiple dots
    const dotCount = (value.match(/\./g) || []).length;
    if (dotCount > 1) {
      value = value.substring(0, value.lastIndexOf('.'));
    }

    // Enforce max 2 decimal places
    if (!this.regex.test(value)) {
      value = value.slice(0, -1);
    }

    input.value = value;
  }

  /** Format value on blur */
  @HostListener('blur')
  onBlur(): void {
    const input = this.el.nativeElement;
    let value = input.value;

    if (!value) return;

    if (value.endsWith('.')) {
      value = value + '00';
    } else if (value.includes('.')) {
      const parts = value.split('.');
      value = parts[0] + '.' + (parts[1] || '').padEnd(2, '0');
    } else {
      value = value + '.00';
    }

    input.value = value;
  }
}